import { ReactNode, useMemo } from 'react';

import { createCtx } from '@pletly/ui';
import { useUserPosts } from './useUserPosts';
import { usePostsFilters } from './usePostsFilters';

type UserPostsHookType = ReturnType<typeof useUserPosts>;
type ContextType = UserPostsHookType & {
	hasCreatedPosts: boolean;
	filters: ReturnType<typeof usePostsFilters>;
};

const [usePosts, PostsDataProvider] = createCtx<ContextType>();

const PostsProvider = ({ children }: { children?: ReactNode }) => {
	const filters = usePostsFilters();
	const { loading, error, posts, refetch, loadMore, hasNextPage, hasCreatedPosts } = useUserPosts({
		filters,
	});

	const value = useMemo(
		() => ({
			loading,
			error,
			posts,
			refetch,
			loadMore,
			hasNextPage,
			filters,
			hasCreatedPosts,
		}),
		[loading, error, posts, refetch, loadMore, hasNextPage, filters, hasCreatedPosts],
	);

	return <PostsDataProvider value={value}>{children}</PostsDataProvider>;
};

export { usePosts, PostsProvider };
